<template>
    <div
        class="detail-bottom-menu layout1"
        v-show="showBottomMenu"
    >
        <div class="item tour" @click="schedulePop()">
            <span class="name">{{ buttonText || $t('md-detail-info.requestShowing') }}</span>
        </div>
    </div>
</template>

<script>
import { mapActions as rootMapActions } from 'pinia';
import { useChatStore } from '@/store';
import global from '@/common/global';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    props: {
        buttonText: {
            type: String,
            default: ''
        },
        theme: {
            required: true,
            type: String
        },
        scroll: {
            type: Boolean,
            default: true
        }
    },
    inject: ['schedulePop'],
    data: function() {
        return {
            showBottomMenu: true
        };
    },
    mounted() {
        if (!this.scroll) {
            return; 
        }
        global.scroll(this.onScroll);
    },
    watch: {
        showBottomMenu: {
            handler(a) {
                if (a) {
                    this.updateChatPosition({ mBottom: '80px' });
                } else {
                    this.resetChatPosition()
                }
            },
            immediate: true
        }
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        ...rootMapActions(useChatStore, ['updateChatPosition', 'resetChatPosition']),
        onScroll() {
            let moduleData = this.$root.moduleData;
            let module = moduleData[moduleData.length - 1];
            let vm = module.vm;
            if (vm && vm.$el) {
                let lastElem = vm.$el;
                let lastRect = lastElem.getBoundingClientRect();
                if (lastRect.bottom - 20 <= window.innerHeight) {
                    this.showBottomMenu = false;
                } else {
                    this.showBottomMenu = true;
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
@media (min-width: 601px) {
    .detail-bottom-menu {
        display: none;
    }
}
@mixin disabled-btn-color($color: #c2c2c2) {
    .item.disabled {
        color: $color;
    }
}
@include media-600 {
    .detail-bottom-menu.layout1 {
        display: flex;
        align-items: center;
        height: 70px;
        font-size: 12px;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        box-shadow: 0 -8px 20px 0 rgba(0, 0, 0, 0.05);
        background-color: #ffffff;
        width: 100%;
        padding: 15px;
        border-radius: 0;
        z-index: 2;
        .item {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: var(--g-btn-background);
            color: #fff;
        }
    }
}
</style>
